import React from 'react';
import { Row, Col, Button, Modal, Form, Input, Popconfirm } from 'antd';
import { DeleteFilled } from '@ant-design/icons';
import { remove } from 'lodash';

const AddDomainPresentational = ({
	onFinish,
	onFinishFailed,
	layout,
	tailLayout,
	handleModalVisible,
	modalVisible,
	domains,
	removeDomain,
	activeDomain,
	handleEditDomain,
	onEditFinish,
	domainListLoading,
}) => {
	//scrolling code
	// const messagesEndRef = useRef(null);
	// const scrollToBottom = () => {
	// 	messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
	// };

	const buttonText = activeDomain && activeDomain.domainName ? 'Save' : 'Save';
	return (
		<Col xl={24} style={{ height: '100%' }}>
			<Row className="domain_container">
				<Modal title="Add Domain" destroyOnClose visible={modalVisible} footer={null} closable={false}>
					<Form
						{...layout}
						name="basic"
						initialValues={{ domain: activeDomain && activeDomain.domainName }}
						onFinish={activeDomain && activeDomain.domainName ? onEditFinish : onFinish}
						onFinishFailed={onFinishFailed}>
						<Form.Item
							label="Domain"
							name="domain"
							rules={[
								{
									required: true,
									message: 'Domain required!',
								},
								{
									// type: 'email',
									pattern: new RegExp('^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:.[a-zA-Z]{2,})+$'),
									message: 'Domain not valid (Ex: abc@example.com)',
								},
							]}>
							<Input autoFocus={modalVisible} />
						</Form.Item>
						<Form.Item {...tailLayout}>
							<Row justify="space-between" style={{ height: '100%' }}>
								<Button style={{ width: '48%', height: '100%' }} type="primary" htmlType="submit">
									{buttonText} Domain
								</Button>
								<Button onClick={() => handleModalVisible(false)} style={{ width: '48%', height: '36px' }}>
									Cancel
								</Button>
							</Row>
						</Form.Item>
					</Form>
				</Modal>
				<Col className="domain_list_container">
					<Col className="domain_list_area">
						{!domainListLoading &&
							domains.map((data, i) => (
								<Col className="domain_list" key={i}>
									<span className="domain" onClick={() => handleEditDomain(data)}>
										{data.domainName}
									</span>
									{(data.key || data.key === 0) && (
										<DeleteFilled onClick={() => removeDomain(data.key)} style={{ color: '#ec0267' }} className="delete_icon" />
									)}
								</Col>
							))}
						{/* <Col ref={messagesEndRef} /> */}
					</Col>
					<Button onClick={() => handleModalVisible(true)} type="ghost" loading={domainListLoading}>
						Add New Domain
					</Button>
				</Col>
			</Row>
		</Col>
	);
};

export default AddDomainPresentational;
